import { on } from "delegated-events";
import { gsap } from "gsap";
import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".events-slider").forEach((el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, Pagination],
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 500,
    simulateTouch: false,
    threshold: 25,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    on: {
      lock: () => {
        el.classList.add("is-locked");
      },
      unlock: () => {
        el.classList.remove("is-locked");
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });

  const showAllToggles = el.querySelectorAll(".show-all-toggle");

  if (showAllToggles.length) {
    showAllToggles.forEach((button) => {
      button.addEventListener("click", () => {
        el.classList.toggle("is-show-all");

        if (el.classList.contains("is-show-all")) {
          swiper.slideTo(0, 0);
          swiper.disable();
        } else {
          el.classList.add("is-enabling");
          swiper.enable();

          setTimeout(() => {
            el.classList.remove("is-enabling");
          }, 300);
        }
      });
    });
  }
});

const slider = document.querySelector(".featured-slider");

if (slider) {
  const container = slider.querySelector(".swiper");
  const numSlides = slider.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    const opts = {
      modules: [A11y, Autoplay, EffectFade, Pagination],
      autoplay: {
        delay: 6000,
        pauseOnMouseEnter: true,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 1000,
      allowTouchMove: false,
      simulateTouch: false,
      pagination: {
        el: slider.querySelector(".slider-pagination"),
        clickable: true,
      },
    };

    new Swiper(container, opts);
  }
}

const blocks = new Map();

on(
  "mouseover",
  ".event-block",
  (e) => {
    const block = e.currentTarget.closest(".event-block");
    const blockId = block.dataset.blockId;
    const screen = block.querySelector(".block-screen");
    const card = block.querySelector(".block-card");
    const content = block.querySelector(".block-content");
    const line = block.querySelector(".block-line");
    const arrow = block.querySelector(".block-arrow");

    const path = line.querySelector(".block-line-path");
    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = 0;

    const existingTimeline = blocks.get(blockId);

    if (existingTimeline) {
      existingTimeline.timeScale(1).play();
    } else {
      const timeline = gsap
        .timeline()
        .fromTo(screen, { opacity: 0 }, { opacity: 1, duration: 0.3 })
        .fromTo(
          card,
          { y: 0 },
          {
            y: () => {
              return content.offsetHeight * -1;
            },
            duration: 0.3,
          },
          "<50%",
        )
        .fromTo(content, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.4 }, "<50%")
        .fromTo(
          path,
          {
            strokeDashoffset: 0,
          },
          {
            strokeDashoffset: -length,
            duration: 0.6,
            ease: "power1.inOut",
          },
          "<50%",
        )
        .fromTo(arrow, { opacity: 0, x: -10, y: 10 }, { opacity: 1, x: 0, y: 0, duration: 0.4 }, "<50%");

      blocks.set(blockId, timeline);
    }
  },
  { capture: true },
);

on(
  "mouseout",
  ".event-block",
  async (e) => {
    const block = e.currentTarget.closest(".event-block");
    const blockId = block.dataset.blockId;

    const timeline = blocks.get(blockId);

    timeline.timeScale(1.5).reverse();
  },
  { capture: true },
);
